export const SCENE_EDIT_ACTION_TYPES = [
  "set_project_material",
  "update_node_parameters",
  "update_nodes_by_filter",
  "update_node_transform",
  "set_front_layout",
  "set_cabinet_role",
  "update_generated_panel",
  "add_cabinet_next_to_selected",
  "delete_selected",
  "ask_clarification",
];

export const SCENE_EDIT_ACTION_SCHEMA = {
  type: "object",
  additionalProperties: false,
  required: ["version", "status", "actions"],
  properties: {
    version: {
      type: "number",
      enum: [1],
    },

    status: {
      type: "string",
      enum: ["needs_clarification", "ready_to_apply"],
    },

    explanation: {
      type: "string",
    },

    questions: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: false,
        required: ["key", "question"],
        properties: {
          key: { type: "string" },
          question: { type: "string" },
          options: {
            type: "array",
            items: { type: "string" },
          },
        },
      },
    },

    actions: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: true,
        required: ["type"],
        properties: {
          type: {
            type: "string",
            enum: SCENE_EDIT_ACTION_TYPES,
          },

          target: {
            type: "string",
            enum: ["selected", "simpleSelected", "project", "scene"],
          },

          id: { type: "string" },

          key: { type: "string" },
          materialId: { type: "number" },

          filter: { type: "object",},

          parameterOverrides: { type: "object" },
          transform: { type: "object" },

          frontType: {
            type: "string",
            enum: ["open", "doors", "drawers", "none"],
          },

          doorCount: { type: "number" },
          drawerCount: { type: "number" },

          cabinetRole: { type: "string" },
          applianceType: { type: "string" },

          direction: {
            type: "string",
            enum: ["left", "right", "front", "back"],
          },

          materialAssignments: { type: "object" },
        },
      },
    },
  },
};